import React from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import Button from '@material-ui/core/Button'
import ActionModal from '../../../common/ActionModal'

const FactorDeleteModal = ({ open, dismissFn, deleteFn, t }) => (
  <ActionModal
    open={open}
    content={t('Want To Delete Factor')}
    dismissText={t('Cancel')}
    onDismiss={dismissFn}
    buttons={[(
      <Button
      color="primary"
      onClick={deleteFn}
      >{t('Delete')}</Button>
      )]}
  />
)

FactorDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  dismissFn: PropTypes.func.isRequired,
  deleteFn: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

export default translate()(FactorDeleteModal)



// WEBPACK FOOTER //
// ./src/components/counseling-session/enter-factors/Modals/Delete.js